export const viewMode = {
  CARD: 'card',
  LIST: 'list'
};

export default viewMode;
